import React from 'react';
import { Star } from 'lucide-react';

const WhyUs = () => {
  const reasons = [
    {
      number: '01',
      title: 'Started by Texas Tech Students',
      description: 'Raider Washing was founded and is owned by Texas Tech University students — built right here in Lubbock, for Lubbock.'
    },
    {
      number: '02',
      title: 'Streak-Free Guarantee',
      description: 'If it\'s not perfect, we come back and fix it. Zero questions asked.'
    },
    {
      number: '03',
      title: 'Fast Response',
      description: 'Quote requests answered within 24 hours. We keep it simple and move fast.'
    },
    {
      number: '04',
      title: 'The Complete 4-in-1 Clean',
      description: 'We don\'t just wipe the glass — we clean the seals, sashes, frames, and panes. Most companies skip three of those. We don\'t.'
    }
  ];

  return (
    <section id="why-us" className="py-24 relative">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="font-['Bebas_Neue'] text-6xl md:text-7xl text-white mb-4">
            WHY CHOOSE <span className="text-[#CC0000]">RAIDER WASHING</span>
          </h2>
        </div>

        <div className="grid lg:grid-cols-3 gap-12">
          {/* Left - Reasons */}
          <div className="lg:col-span-2 space-y-8">
            {reasons.map((reason, index) => (
              <div 
                key={index}
                className="group bg-gradient-to-br from-zinc-900 to-black border border-zinc-800 rounded-lg p-8 hover:border-[#CC0000] transition-all duration-300"
              >
                <div className="flex gap-6">
                  <div className="font-['Bebas_Neue'] text-5xl text-[#CC0000] opacity-50 group-hover:opacity-100 transition-opacity duration-300">
                    {reason.number}
                  </div>
                  <div className="flex-1">
                    <h3 className="font-['Bebas_Neue'] text-3xl text-white mb-3 tracking-wide">
                      {reason.title}
                    </h3>
                    <p className="text-gray-400 leading-relaxed text-lg">
                      {reason.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Right - Stats Panel */}
          <div className="lg:col-span-1">
            <div className="sticky top-24 bg-gradient-to-br from-[#CC0000] to-[#990000] rounded-lg p-8 shadow-2xl">
              <div className="text-center space-y-6">
                <div className="flex justify-center gap-1 mb-4">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} className="fill-white text-white" size={32} />
                  ))}
                </div>
                
                <div className="border-t border-white/30 pt-6">
                  <div className="font-['Bebas_Neue'] text-6xl text-white mb-2">
                    100%
                  </div>
                  <div className="text-white text-lg font-semibold">
                    Satisfaction Guarantee
                  </div>
                </div>

                <div className="border-t border-white/30 pt-6">
                  <div className="font-['Bebas_Neue'] text-6xl text-white mb-2">
                    24HR
                  </div>
                  <div className="text-white text-lg font-semibold">
                    Quote Response Time
                  </div>
                </div>

                <div className="border-t border-white/30 pt-6">
                  <div className="text-white text-sm leading-relaxed">
                    Founded and operated by Texas Tech University students serving Lubbock and West Texas
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
